// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mQs_","selected":"styles_selected__m46Fq"};